<template>
  <header class="header">
    <IntegrationModal :code="code"
                      :integration="integration"
                      @set-integration="setIntegration"></IntegrationModal>
  </header>
</template>
<script>
    import IntegrationModal from './integration-modal/IntegrationModal'
export default {
    components: {
        IntegrationModal
    },

    methods: {
      setIntegration(integration) {
        this.integration = integration
      }
    },

    data() {
      return {
        code: undefined,
        integration: undefined
      }
    },
    
    created() {
      this.code = this.$route.query.code;
    }
}
</script>
<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
